export default "__VITE_ASSET__BvIynFmf__"